import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "hooks/useTableWithPost";
import { RetailerPlanData } from "config/tableConfigs";
import RetailerPlanFormModal from "./components/RetailerPlanFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";

const RetailerPlanPage = () => {
  const [modalShow, setModalShow]       = useState(false);
  const [modalMode, setModalMode]       = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]           = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/retailer_plan_action",
    RetailerPlanData,
    formdata,
    refresh
  );

  const handleAddUser  = () => { setModalMode("add"); setSelectedUser(null); setModalShow(true); };
  const handleEditUser = (user) => { setModalMode("edit"); setSelectedUser(user); setModalShow(true); };
  const handleDelete   = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const el = document.getElementById("deleteRetailerPlan");
      if (el) window.bootstrap.Modal.getOrCreateInstance(el).show();
    }, 100);
  };

  return (
    <div>
      <PageWrapperForm config={RetailerPlanData} handleOnclick={handleAddUser} buttonTitle="Assign Plan to Retailer">
        <DataTable
          config={RetailerPlanData}
          tableData={tableData}
          onEdit={handleEditUser}
          onDelete={handleDelete}
        />
      </PageWrapperForm>

      <RetailerPlanFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={() => { setRefresh(p => p + 1); setModalShow(false); }}
      />

      <DeleteModal
deleteid={selectedUser?.id}
        id="deleteRetailerPlan"
        title="Remove Plan Assignment"
        message="Are you sure you want to remove this plan assignment?"
        apiUrl="https://pro.mokshiq.in/retailer_plan_action"
        onSuccess={() => setRefresh(p => p + 1)}
      />
    </div>
  );
};

export default RetailerPlanPage;